module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-01-637b3d835175354e594f08d4183b9ab2.svg";